import * as Yup from 'yup';

export const RegistrationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  phone_number: Yup.string()
    .required('Phone number is required')
    .matches(/^[0-9]{10}$/, 'Phone number must be 10 digits'),
  email_address: Yup.string()
    .required('Email is required')
    .email('Please enter valid email address'),
}); 